export function SAVE_WELCOME_BANNER(state, [welcome_banner]){
    state.welcome_banner = welcome_banner
}